import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import PackagingItemNewEditForm from '../packaging-item-new-edit-form';

export default function PackagingItemCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new packaging item"
        links={[
          {
            name: 'Packaging Items',
            href: paths.dashboard.packagingItem.root,
          },
          { name: 'Create a new packaging item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingItemNewEditForm />
    </Container>
  );
}
